import { useMemo } from 'react';

export function useAccountType(selectedRole: string | null) {
  const isLegalEntity = useMemo(() => {
    if (!selectedRole) return false;
    const legalEntities = ['posto', 'transportadora', 'revenda'];
    return legalEntities.includes(selectedRole.toLowerCase());
  }, [selectedRole]);

  return { isLegalEntity };
}